<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group>

    <el-table :data="tempRebates" resource="temp-rebates" v-loading="loading">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column align="center" header-align="center" label="账户">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <!-- <br>
            <span>{{ scope.row.user.idcard_no }}</span> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rebate_type_text" label="类型" />
      <el-table-column prop="final_money" label="金额">
        <template slot-scope="scope">
          初始:{{ scope.row.flow_money }}<br />
          最终:{{ scope.row.final_money }}
        </template>
      </el-table-column>
      <el-table-column prop="status_text" label="结算信息">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="warning" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="success" disable-transitions>{{ scope.row.status_text }} </el-tag>
          <el-tag v-else type="danger" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <br />
          预结算:{{ scope.row.to_settle_time }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="to_settle_time" label="预结算" /> -->
      <el-table-column prop="order_id" label="订单号" />
      <el-table-column label="贡献信息">
        <template slot-scope="scope">
          <div v-if="scope.row.contrib_level_info">
            贡献人: <span>{{ scope.row.contrib_depth }}级({{ scope.row.contrib_level_info.level_name }})</span>
          </div>
          <!-- <br /> -->
          描述:{{ scope.row.rebate_desc }}<br />
          时间:{{ scope.row.created_at }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="created_at" label="添加时间" /> -->

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="hasPermsLogList" @click="operateLog(scope.row)" size="small">查看日志</el-button>
          <el-button-group>
            <el-button v-if="scope.row.status === 0 && hasPermsDeductBonus" @click="deductBonus(scope.row)" size="small" type="warning"
              >扣除奖金
            </el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog title="变动日志" :visible.sync="dialogTempRebateLogsVisible" v-loading="loading" append-to-body>
      <el-table :data="tempRebateLogs">
        <el-table-column property="op_name" label="操作人" />
        <el-table-column property="log_type_text" label="操作类型" />
        <el-table-column property="amount" label="变动金额" />
        <el-table-column property="created_at" label="变动时间" />
        <el-table-column property="remark" label="备注" />
      </el-table>
      <div>
        <el-pagination
          @current-change="tempRebateLogsPageChange"
          :current-page.sync="tempRebateLogsPage.current_page"
          :page-size="tempRebateLogsPage.per_page"
          layout="total, prev, pager, next,jumper"
          :total="tempRebateLogsPage.total"
        />
      </div>
    </el-dialog>

    <el-dialog title="扣除奖金" :visible.sync="deductBonusDialogVisible" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="form"
        :submit="onDeductBonusSubmit"
        :errors.sync="errors"
        :form.sync="form"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="总金额">
          <el-input type="text" disabled v-model="form.final_money" />
        </el-form-item>
        <el-form-item label="扣除" prop="deductMoney" required>
          <el-input type="text" v-model="form.deductMoney" />
        </el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getTempRebates, tempRebateLogsList, deductBonusManage } from '@/api/temp-rebates'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'
import LzForm from '@c/LzForm'
import { getFirstError, getMessage, can } from '@/libs/utils'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    LzForm,
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '代理商',
        },
        {
          field: 'rebate_type',
          label: '奖金类型',
          type: 'el-select',
          // <!-- 0 复购奖金,1 推荐注册奖金,2 加盟订单奖励,3 推荐升级奖金,4 发货中心奖 -->
          options: [
            { id: 0, name: '复购奖金' },
            { id: 1, name: '推荐注册奖金' },
            { id: 2, name: '加盟订单奖励' },
            {
              id: 3,
              name: '推荐升级奖金',
            },
            { id: 4, name: '发货中心奖' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'status',
          label: '结算状态',
          type: 'el-select',
          // <!-- 0 待结算 1 已结算 2 结算前作废 3 不参与结算 -->
          options: [
            { id: 0, name: '待结算' },
            { id: 1, name: '已结算' },
            { id: 2, name: '结算前作废' },
            {
              id: 3,
              name: '不参与结算',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'order_id',
          label: '订单号',
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker',
        },
      ],
      tempRebates: [],
      page: null,
      deductBonusDialogVisible: false,
      dialogTempRebateLogsVisible: false,
      tempRebateLogs: [],
      tempRebateLogsPage: {},
      tempRebateLogsQueryData: {},
      loading: true,
      form: {
        id: 0,
        final_money: 0,
        deductMoney: '',
      },
      errors: {},
      loadingInstance: {},
      hasPermsDeductBonus: false,
      hasPermsLogList: false,
    }
  },
  created() {
    this.hasPermsDeductBonus = can('temp-rebates.deductBonus')
    this.hasPermsLogList = can('temp-rebate-logs.list')
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.loadData(newVal.query)
      },
      immediate: true,
    },
  },
  methods: {
    async loadData(newVal) {
      const {
        data: { data, meta },
      } = await getTempRebates(newVal)
      this.tempRebates = data
      this.page = meta
      this.loading = false
    },
    operateLog(row) {
      this.dialogTempRebateLogsVisible = true
      this.tempRebateLogsQueryData.id = row.id
      this.tempRebateLogsList()
    },
    async tempRebateLogsList() {
      this.loading = true
      const {
        data: { data, meta },
      } = await tempRebateLogsList(this.tempRebateLogsQueryData)
      this.tempRebateLogs = data
      this.tempRebateLogsPage = meta
      this.loading = false
    },
    tempRebateLogsPageChange(val) {
      this.tempRebateLogsQueryData.page = val
      this.tempRebateLogsList()
    },
    async deductBonus(row) {
      this.deductBonusDialogVisible = true
      this.form.id = row.id
      this.form.final_money = row.final_money
    },
    async onDeductBonusSubmit() {
      try {
        const { data } = await deductBonusManage(this.form.id, this.form)
        this.deductBonusDialogVisible = false
        this.$message.success(data)
        this.clearForm()
        await this.loadData({})
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    clearForm() {
      this.form = {
        id: 0,
        final_money: 0,
        deductMoney: '',
      }
    },
  },
}
</script>
